export const LOADED = 'user/LOADED'

export const AUTHENTICATION_REQUEST = 'user/AUTHENTICATION_REQUEST'
export const AUTHENTICATION_SUCCESS = 'user/AUTHENTICATION_SUCCESS'
export const AUTHENTICATION_FAILURE = 'user/AUTHENTICATION_FAILURE'

export const LOGOUT = 'user/LOGOUT'



// WEBPACK FOOTER //
// ./src/redux/user/action-types.js